<template>
  <div>
    <!-- 电脑 -->
    <div class="homeNews" v-if="$store.state.webNavigator=='pc'">
      <div class="home-news marginAuto max1720">
        <div>
          <div class="flexSpace">
            <p class="part-title list-tlt displayIB">健康瘦身资讯<span class="list-tlt-tip">-</span></p>
            <!--            <div class="goto displayIB">-->
            <!--              <vue-link :to="{path:'/weightLossInfo/减肥知识.html'}"><img class="more-icon"-->
            <!--                                                                      src="https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/pc_home/goto.png"-->
            <!--                                                                      alt=""></vue-link>-->
            <!--            </div>-->
          </div>
          <div class="news-list">
            <div class="news-list-bar displayIB" v-for="(item , index) in bannerData" :key="index">
              <div class="news-list-Left displayIB pointEr" @click="gotoPath2(item.bannerDataUrl,index,0)">
                <img class="news-list-img" :src="httptype(item.bannerImg)" alt="" title="">
                <p class="news-list-LeftText overflowText">&nbsp;&nbsp;{{' ● '+item.bannerImgName}}</p>
              </div>
              <div class="news-list-Right displayIB">
                <p class="news-list-Tlt"><span class="news-list-tip"></span>{{item.bannerName}}</p>
                <p class="overflowText news-list-RightText pointEr"
                   v-for="(item2 , index2) in item.bannerList"
                   :key="index2"
                   @click="gotoPath2(item2,index,0)">{{'● '+item2.articleTitle}}</p>
              </div>
            </div>
            <!-- <div v-if="bannerList4.length>0" class="news-list-bar displayIB">
              <div class="news-list-Left displayIB pointEr" @click="gotoPath2(bannerImgUrl4,0,1)">
                <img class="news-list-img" :src="httptype(bannerImg4)" alt="" title="">
                <p class="news-list-LeftText overflowText">&nbsp;&nbsp;{{' ● '+bannerImgName4}}</p>
              </div>
              <div class="news-list-Right displayIB">
                <p class="news-list-Tlt"><span class="news-list-tip"></span>案例分享</p>
                <p class="overflowText news-list-RightText pointEr"
                   v-for="(item , index) in bannerList4"
                   :key="index"
                   @click="gotoPath2(item,0,1)">{{'● '+item.articleTitle}}</p>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- 移动 -->
    <div class="phone-page" v-else>
      <div class="PhoneHome-title">
        健康瘦身资讯 <span class="col00CDA2">-</span>
      </div>
      <div class="news-list">
        <div class="news-list-bar displayIB" v-for="(item , index) in bannerData" :key="index">
          <div class="news-list-Left displayIB pointEr positionRE" @click="gotoPath2(item.bannerDataUrl,index,0)">
            <img class="news-list-img" :src="httptype(item.bannerImg)" alt="" title="">
            <p class="news-list-LeftText overflowText positionAB">&nbsp;&nbsp;{{'● '+item.bannerImgName}}</p>
          </div>
          <div class="news-list-Right displayIB">
            <p class="news-list-Tlt"><span class="news-list-tip">| </span>{{item.bannerName}}</p>
            <p class="overflowText news-list-RightText pointEr"
               v-for="(item2 , index2) in item.bannerList"
               :key="index2"
               v-if="index2>0&&index2<=4"
               @click="gotoPath2(item2,index,0)">{{'● '+item2.articleTitle}}</p>
          </div>
        </div>
        <!-- <div v-if="bannerList4.length>0" class="news-list-bar displayIB">
          <div class="news-list-Left displayIB pointEr positionRE" @click="gotoPath2(bannerImgUrl4,0,1)">
            <img class="news-list-img" :src="httptype(bannerImg4)" alt="" title="">
            <p class="news-list-LeftText overflowText positionAB">&nbsp;&nbsp;{{'● '+bannerImgName4}}</p>
          </div>
          <div class="news-list-Right displayIB">
            <p class="news-list-Tlt"><span class="news-list-tip">| </span>案例分享</p>
            <p class="overflowText news-list-RightText pointEr"
               v-for="(item , index) in bannerList4"
               :key="index"
               v-if="index>0&&index<=4"
               @click="gotoPath2(item,0,1)">{{'● '+item.articleTitle}}</p>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import {$get, $post, } from '@/others/ajax';
import config from '@/others/interface';
import {myFun} from '../../../../plug/modifyImagePath'

export default {
  name: 'homeNews',
  props: {
    loadType: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      reg: /<\/?.+?\/?>/g,
      imgUrl: 'https://jusexcx.zmelo.com/',
      bannerData: [],
      // 栏目图片
      bannerImg4: '',
      // 栏目图片名字
      bannerImgName4: '',
      // 栏目url
      bannerImgUrl4: '',
      // 栏目
      bannerList4: [], // 栏目列表4
      router4: '',
    };
  },
  methods: {
    async getClass () {
      let res = await $get(config.zmlgw + '/web/getEndClass');
      if (res.code == 200) {
        let bannerData;
        res.returnData[0].data.map((item, index) => {
          this.$get(`${config.zmlgw}/web/getList`, {code: item.id, pageSize: 5, pageIndex: 1, }).then(res2 => {
            if (res2.code === 200) {
              bannerData = {
                bannerName: item.text,
                bannerList: res2.data.rows,
                bannerDataUrl: res2.data.rows[0],
                bannerImg: res2.data.rows[0].articleImg,
                bannerImgName: res2.data.rows[0].articleTitle,
              };
              this.bannerData.push(bannerData);
            }
          });
        });
      }
      this.getBanner4();
    },
    async getBanner4 () {
      let res = await $get(config.zmlgw + '/web/getList', {code: 'A10', pageSize: 5, pageIndex: 1, });
      if (res.code == 200) {
        if (res.data.count > 0) {
          this.bannerList4 = res.data.rows;
          this.bannerImgUrl4 = res.data.rows[0];
          this.bannerImg4 = res.data.rows[0].articleImg;
          this.bannerImgName4 = res.data.rows[0].articleTitle;
        }
      }
    },
    httptype (url) { // 图片判断
      if (url) {
        url.toString();
        if (url.indexOf('http') == '-1') {
          return this.imgUrl + url;
        } else {
          return myFun(url);
        }
      }
      return '';
    },

    goMore () {
      this.$router.push({path: '/weightLossInfo/jianfeizhishi.html', });
    }, // 查看更多
    gotoPath2 (item, index, type) {
      console.log(item,index,type)
      let brandInfo;
      if (type === 0) {
        let helpcode = pinyinUtil.getPinyin(item.secondaryColumnName, '', false, false);
        brandInfo = {
          toLeveListPath: item.articleid,
          articleKeyWord: item.articleKeyWord,
          bannerName: item.secondaryColumnName,
          secondColumnId: item.secondaryColumnId,
          toLeveRouter: `/InformationList/${item.secondaryColumnId}/${index}/1/${helpcode}.html`,
        };
      } else {
        brandInfo = {
          toLeveListPath: item.articleid,
          articleKeyWord: item.articleKeyWord,
          bannerName: item.secondaryColumnName,
          secondColumnId: item.secondaryColumnId,
          toLeveRouter: '/caseSharing/1/1/anlifenxiang.html',
        };
      }
      sessionStorage.setItem('brandInfo', JSON.stringify(brandInfo));
      this.$router.push({path: '/brandNewsInfo/' + item.articleid + '/1/' + item.articleid + '.html', });
    },
  },
  mounted () {
    if (sessionStorage.getItem('brandInfo')) {
      sessionStorage.removeItem('brandInfo');
    }
    this.getClass();
  },
};
</script>

<style lang="less" scoped>
  @import url('../../../../../static/css/fontSize.less');

  @media screen and (max-width: 800px) {
    .phone-page {
      padding: 67*@width1 0 0;
    }

    .PhoneHome-title {
      margin-bottom: 59*@width1;
    }

    .news-list {
      flex-wrap: wrap;
      margin-bottom: 40*@width1;
    }

    //1.1.1
    .news-list-bar {
      width: 325*@width1;
      margin-bottom: 41*@width1;
    }

    .news-list-bar:nth-child(2n) {
      margin-left: 40*@width1;
    }

    .news-list-Left, .news-list-img {
      width: 325*@width1;
      height: 218*@width1;
    }

    .news-list-LeftText {
      width: 100%;
      height: 36*@width1;
      background: rgba(0, 205, 162, 0.65);
      color: #FFFFFF;
      font-size: 22*@width1;
      left: 0;
      bottom: 0;
    }

    .news-list-Tlt {
      font-size: 34*@width1;
      line-height: 77*@width1;
      color: #282828;
    }

    .news-list-tip {
      color: #00CDA2;
    }

    .news-list-Right {
      width: 281*@width1;
    }

    .news-list-RightText {
      font-size: 22*@width1;
      color: #666666;
      line-height: 30*@width1;
    }
  }

  @media screen and (min-width: 800px) {
    .home-news {
    }

    .news-list {
      margin-top: 11*@width;
      margin-bottom: 25*@width;
    }

    .news-list-Text {
      width: 208*@width;
      text-align: left;
    }

    .more-icon {
      width: 41*@width;
      height: 13.5*@width;
    }

    .shubiao-icon {
      width: 11*@width;
      height: 23.5*@width;
      margin: 11*@width 0 43*@width 0;
    }

    //1.1.1
    .news-list-bar {
      width: 50%;
      height: 93*@width;
      margin-bottom: 31*@width;
    }

    .news-list-Left {
      position: relative;
      width: 127*@width;
      height: 93*@width;
      margin-right: 11*@width;
    }

    .news-list-LeftText {
      position: absolute;
      bottom: 0;
      width: 127*@width;
      height: 13*@width;
      background: rgba(0, 0, 0, 0.5);
      color: #ffffff;
      font-size: 7*@width;
      /*text-align: center;*/
      line-height: 12*@width;
    }

    .news-list-last-bar {
      margin-right: 0;
    }

    .news-list-img {
      width: 127*@width;
      height: 93*@width;
    }

    .news-list-Right {
      width: 143*@width;
      height: 93*@width;
    }

    .news-list-RightText {
      font-size: 7*@width;
      color: #666666;
      line-height: 12*@width;
    }

    .news-list-Tlt {
      font-size: 16*@width;
      line-height: 39*@width;
    }

    .news-list-tip {
      width: 1*@width;
      height: 15*@width;
      border: 1px solid rgba(0, 205, 162, 1);
      margin-right: 6*@width;
      vertical-align: middle;
    }
  }

</style>



// WEBPACK FOOTER //
// homeNews.vue